import React from 'react';

const ArrowBack = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="rcx-svg--directional"
    fill="currentColor"
    {...props}
  >
    <path d="M11.7071 9.29289C11.3166 8.90237 10.6834 8.90237 10.2929 9.29289L4.29289 15.2929C3.90237 15.6834 3.90237 16.3166 4.29289 16.7071L10.2929 22.7071C10.6834 23.0976 11.3166 23.0976 11.7071 22.7071C12.0976 22.3166 12.0976 21.6834 11.7071 21.2929L7.41421 17H25.5V21C25.5 21.5523 25.9477 22 26.5 22C27.0523 22 27.5 21.5523 27.5 21V16C27.5 15.4477 27.0523 15 26.5 15H7.41421L11.7071 10.7071C12.0976 10.3166 12.0976 9.68342 11.7071 9.29289Z" />
  </svg>
);

export default ArrowBack;
